<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>
<script>


  import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
  export default {
    data() {
      return {


        locale: zhCN
      };
    },
  }
</script>
<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  div.bread-box{
    padding-left:210px;
  }
  >div.layout{
    div.container{
      width:100%;
      position: absolute;
      top:147px;
      left:0;
      padding-left:210px;
    }

  }
  .side-bar{
    width:200px;
    position: fixed;
    left: 0;
    top: 90px;
    bottom: 0;
    background: #2c3049;
  }
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
